export default __webpack_public_path__ + "static/media/about.af0bcf26.jpg";